import { render, staticRenderFns } from "./SignUpNotificationPopover.vue?vue&type=template&id=82d5ff20&scoped=true&"
import script from "./SignUpNotificationPopover.vue?vue&type=script&lang=ts&"
export * from "./SignUpNotificationPopover.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpNotificationPopover.vue?vue&type=style&index=0&id=82d5ff20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d5ff20",
  null
  
)

/* custom blocks */
import block0 from "./SignUpNotificationPopover.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports